import script from "./SettlementAttorneyFeeStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettlementAttorneyFeeStep.vue?vue&type=script&setup=true&lang=ts"

import "./SettlementAttorneyFeeStep.vue?vue&type=style&index=0&id=36c7e4b3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c7e4b3"]])

export default __exports__